import styled from 'styled-components';

export const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 300px;
  padding: 20px;
`;
